import { AuthUserModel } from '~/api/auth/auth-user.model';

type AccessTokenPayload = AuthUserModel & {
  exp?: number;
};

const decodeBase64Url = (value: string): string => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padding = normalized.length % 4 === 0 ? '' : '='.repeat(4 - (normalized.length % 4));
  return atob(`${normalized}${padding}`);
};

export const decodeAccessToken = (token: string): AccessTokenPayload | null => {
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    return JSON.parse(decodeBase64Url(parts[1])) as AccessTokenPayload;
  } catch {
    return null;
  }
};

export const isAccessTokenExpired = (token: string): boolean => {
  const payload = decodeAccessToken(token);
  if (!payload?.exp) {
    return true;
  }

  return payload.exp * 1000 <= Date.now();
};
